import { defineMessages, type IntlShape } from 'react-intl';
import type { BlockConfigBase, JSONSchema } from '@plone/types';

export interface ProductsTitleData extends JSONSchema {
  '@type': 'productstitle';
  main_page_title: string;
  placeholder?: string;
}

const ProductsTitleSchema = ({
  data,
  intl,
}: {
  data: ProductsTitleData;
  intl: IntlShape;
}): JSONSchema => {
  const schema = {
    title: intl.formatMessage(messages.products_menu_title),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['main_page_title'],
      },
    ],
    properties: {
      main_page_title: {
        title: intl.formatMessage(messages.products_menu_title_title),
        description: intl.formatMessage(
          messages.products_menu_title_description,
        ),
      },
    },
    required: [],
  };

  return schema;
};

const messages = defineMessages({
  products_menu_title: {
    id: 'products_menu_title',
    defaultMessage: 'Products menu',
  },
  products_menu_title_title: {
    id: 'products_menu_title_title',
    defaultMessage: 'Main page title',
  },
  products_menu_title_description: {
    id: 'products_menu_title_description',
    defaultMessage:
      'Enter text here to replace the title of the main tab. The default is "Overview"',
  },
});

export interface ProductsMenuConfig
  extends Omit<BlockConfigBase, 'blockSchema'> {
  blockSchema: typeof ProductsTitleSchema;
}

export default ProductsTitleSchema;
